import { useQuery } from 'react-query';
import { authFetch } from '../../../../../../../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../../../../../../../CommonUtils/urlWithParams';

export interface Client {
  FirstName: string;
  LastName: string;
  Email: string | null;
  Id: number;
}

export const fetchClientList = async (clientsOnly: boolean): Promise<Client[]> => {
  const url = urlWithParams(
    '/Adviser/Adviser/GetClients',
    clientsOnly ? { clientsOnly: true } : undefined,
    { skipNulls: true },
  );
  const { Clients } = await authFetch(url);

  return Clients;
};

export const useClientListQuery = (clientsOnly: boolean) => {
  return useQuery(
    ['Profile', 'Accounts', 'MoveAccount', 'ClientList', clientsOnly],

    () => fetchClientList(clientsOnly),

    { cacheTime: 0 },
  );
};
